import { Injectable } from '@angular/core';
import { Channel, Socket } from 'phoenix';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SsrLocalstoreService } from '../_services/ssr-localstore.service';

@Injectable({
    providedIn: 'root'
})
export class MatchCommentService {
    private socket: Socket = {} as Socket;
    private MatchCommentChannel: Channel = {} as Channel;
    private socket_uri: string = ``;
    public messages: Subject<any> = new Subject()

    constructor(
        private ssr: SsrLocalstoreService
    ) {
        this.socket_uri = `${environment.ELIXIR_SOCKET_HOST}/socket`;
    }

    setConnectionDetails() {
        if (this.ssr.isClientSide) {
            return new Promise((completed) => {
                this.socket = new Socket(this.socket_uri);
                this.MatchCommentChannel = this.socket.channel(`account_ticker:${environment.TENNIS_ONE_ACCOUNT_ID}`)
                completed(true);
            });
        }
        return
    }

    async connectToSocket(): Promise<any> {
        if (this.ssr.isClientSide) {
            return new Promise(async (completed) => {
                this.setConnectionDetails();
                this.socket.connect();

                this.socket.onError((err) => {
                    this.socket.disconnect()
                    console.error('Error connection to socket', err)
                    completed(false)
                })
                this.joinChannel();
                completed(true);
            });
        }
    }

    channelUpdates(): Observable<any> {
        return new Observable((observer) => {
            if (this.MatchCommentChannel && this.MatchCommentChannel.state) {
                this.MatchCommentChannel.on('new_ticker', (update: { data: { body: string }, type: string }) => {
                    // observer.next(update);
                    this.messages.next(update)
                });
            }
        });
    }

    joinChannel() {
        this.MatchCommentChannel
            .join()
            .receive('ok', (res: { recent_ticker_messages: { data: { body: string } }[] }) => {
                this.messages.next({
                    ...res.recent_ticker_messages[0],
                    type: 'new_ticker'
                })
                return;
            })
            .receive('error', (response) => {
                const error = 'Joining channel failed';
                console.error(error, response);
            });
    }

    // disconnect() {
    //     if (this.MatchCommentChannel) {
    //         this.MatchCommentChannel.leave();
    //     }
    //     if (this.socket) {
    //         this.socket.disconnect();
    //     }
    // }
}
